import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "form1" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "story" }
const _hoisted_5 = { class: "panel" }
const _hoisted_6 = { class: "panel_left" }
const _hoisted_7 = { class: "image-slot" }
const _hoisted_8 = { class: "panel_right" }
const _hoisted_9 = { class: "example1" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"white-space":"pre-wrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h2", null, "关卡谜题提示", -1)),
    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_el_button, {
      size: "large",
      style: {"background":"#409eff","color":"#fff"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addTip(this.detailId)))
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
        _createTextVNode("新增提示", -1)
      ]))]),
      _: 1
    }),
    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_VueDraggable, {
      ref: "el",
      modelValue: _ctx.fileList2,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList2) = $event)),
      class: "content"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList2, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "lunBo",
            onClick: ($event: any) => (_ctx.changeTip(index)),
            style: _normalizeStyle(item.active == true ? 'background:#9a9a9a' : 'background:black')
          }, [
            _createTextVNode(_toDisplayString(`提示${item.key + 1}`) + " ", 1),
            _createElementVNode("span", {
              onClick: ($event: any) => (_ctx.deleteTip(index, $event))
            }, "X", 8, _hoisted_3)
          ], 12, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            style: {"max-width":"600px"},
            "label-position": "top",
            rules: _ctx.rules,
            ref: "ruleForm",
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "谜题提示标题",
                prop: "puzzleTitle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.puzzleTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.puzzleTitle) = $event)),
                    size: "large"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "谜题提示内容",
                prop: "puzzleContent"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.puzzleContent,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.puzzleContent) = $event)),
                    type: "textarea",
                    size: "large",
                    rows: "10",
                    maxlength: "1000",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "谜题提示图片",
                prop: "puzzleCover"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: _ctx.UpdateApi,
                    "show-file-list": false,
                    "on-success": _ctx.handleAvatarSuccess,
                    "before-upload": _ctx.beforeAvatarUpload,
                    "file-list": _ctx.fileList,
                    disabled: _ctx.allowUpload
                  }, {
                    default: _withCtx(() => [
                      (_ctx.form.puzzleCover)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            src: _ctx.form.puzzleCover,
                            class: "avatar",
                            alt: "",
                            fit: 'contain'
                          }, {
                            error: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_icon_picture)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["src"]))
                        : (_openBlock(), _createBlock(_component_el_icon, {
                            key: 1,
                            class: "avatar-uploader-icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
                ]),
                _: 1
              }),
              (_ctx.allowUpload)
                ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        onClick: _ctx.clearImage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "title" }, "App示意图", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, [
              _createElementVNode("span", null, [
                _createVNode(_component_el_icon, { size: "20" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeft)
                  ]),
                  _: 1
                })
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "提示", -1)),
              _createElementVNode("span", null, [
                _createVNode(_component_el_icon, { size: "20" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowRight)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.form.puzzleTitle), 1),
            _withDirectives(_createElementVNode("p", null, [
              _createElementVNode("img", {
                src: _ctx.form.puzzleCover,
                alt: ""
              }, null, 8, _hoisted_10),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.form.puzzleContent), 1)
            ], 512), [
              [_vShow, _ctx.showTip]
            ]),
            _withDirectives(_createElementVNode("p", null, [
              _createVNode(_component_el_icon, { size: "220" }, {
                default: _withCtx(() => [
                  _createVNode(_component_QuestionFilled)
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, !_ctx.showTip]
            ]),
            _createElementVNode("p", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showTip = !_ctx.showTip))
            }, "开启提示")
          ])
        ])
      ])
    ])
  ]))
}